import SetupPanel from './SetupPanel';

export default SetupPanel;
